var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { InternalProvider } from '../../util/InternalProvider';
import useGenerateId from '../../util/useGenerateId';
import { isEmpty } from '../../util/isEmpty';
import { TextareaInputElement, TextareaLabel, TextareaContainer, TextareaHelperText, } from './elements';
export var Textarea = React.forwardRef(function (_a, fRef) {
    var label = _a.label, incomingId = _a.id, _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.helperText, helperText = _e === void 0 ? '' : _e, _f = _a.containerClassName, containerClassName = _f === void 0 ? '' : _f, _g = _a.inputClassName, inputClassName = _g === void 0 ? '' : _g, _h = _a.labelClassName, labelClassName = _h === void 0 ? '' : _h, _j = _a.helperTextClassName, helperTextClassName = _j === void 0 ? '' : _j, _k = _a.fieldStatus, fieldStatus = _k === void 0 ? 'default' : _k, restProps = __rest(_a, ["label", "id", "name", "value", "isDisabled", "helperText", "containerClassName", "inputClassName", "labelClassName", "helperTextClassName", "fieldStatus"]);
    var id = useGenerateId('text-field', incomingId);
    var showHelperText = !isEmpty(helperText);
    return (React.createElement(InternalProvider, null,
        React.createElement(TextareaContainer, { id: id + "-field-container", key: id + "-field-container", className: containerClassName },
            React.createElement(TextareaInputElement, __assign({ "aria-label": label, placeholder: " ", id: id, ref: fRef, name: name, disabled: isDisabled, fieldStatus: fieldStatus, showHelperText: showHelperText, className: inputClassName, value: value }, restProps)),
            React.createElement(TextareaLabel, { htmlFor: "textarea", fieldStatus: fieldStatus, className: labelClassName }, label),
            showHelperText && (React.createElement(TextareaHelperText, { fieldStatus: fieldStatus, className: helperTextClassName, "data-testid": "helper-text" }, helperText)))));
});
